<!--suppress ALL -->
<template>
  <div>
    <spinner v-if="loading" size="200" />

    <v-tabs v-else grow>
      <v-tab>Nouveauté</v-tab>
      <v-tab>Blog</v-tab>

      <v-tab-item class="pb-16">
        <div class="cardContainer">
          <h1>La petite nouveauté</h1>

          <v-form>
            <v-text-field v-model="novelty.title" label="Titre" />
            <v-textarea v-model="novelty.text" label="Texte" />
            <v-file-input v-model="novelty.file" label="Photo" />
            <v-text-field v-model="novelty.link" label="Link" />
          </v-form>

          <div class="flex align-center">
            <v-btn :disabled="disabled" color="success" @click="uploadNovelty"
              >Valider
            </v-btn>
            <h5 class="ml-10">counter: {{ novelty.text.length }}</h5>
          </div>
        </div>
      </v-tab-item>

      <v-tab-item class="pb-16">
        <div class="cardContainer">
          <h1>La dernière actu</h1>

          <v-form>
            <v-text-field v-model="blog.title" label="Titre" />
            <v-textarea v-model="blog.text" label="Texte" />
            <v-file-input v-model="blog.file" label="Photo" />
            <v-text-field v-model="blog.link" label="Link" />
          </v-form>

          <div class="flex align-center">
            <v-btn :disabled="disabled" color="success" @click="uploadBlog"
              >Valider
            </v-btn>
            <h5 class="ml-10">counter: {{ blog.text.length }}</h5>
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import {
  apiCallRebuild,
  notifyErrorFetchRaw,
  notifyKO,
  notifyOk,
} from "@/helper";
import { api, API_ROUTES } from "@/Services/api.common.service";

export default {
  data() {
    return {
      loading: true,
      disabled: false,

      novelty: {},
      blog: {},
    };
  },

  watch: { $route: "fetchData" },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      const notifyError = notifyErrorFetchRaw.bind(this);

      try {
        const resApi = await apiCallRebuild(API_ROUTES.adminAnimation);

        this.blog = resApi?.blog?.animation;
        this.novelty = resApi?.novelty?.animation;

        this.loading = false;
      } catch (e) {
        console.error(e);
        notifyError();
      }
    },
    async post(type) {
      this.disabled = true;
      const notifyErrorFetch = notifyErrorFetchRaw.bind(this);
      const notifyBad = notifyKO.bind(this);
      const notify = notifyOk.bind(this);

      if (!this[type].file) {
        notifyBad("Pas de fichier");
        this.disabled = false;
        return;
      }

      try {
        const data = {
          title: this[type].title,
          text: this[type].text,
          link: this[type].link,
        };

        const formData = new FormData();

        formData.append("image", this[type].file, this[type].file.name);
        Object.keys(data).forEach((key) => formData.append(key, data[key]));

        await api(true).put(API_ROUTES.adminAnimation[type], formData);

        notify("Mise à jour Ok");
      } catch (e) {
        notifyErrorFetch();
        console.error(e);
      }
      this.disabled = false;
    },
    //    **************************************************************************
    async uploadNovelty() {
      this.post("novelty");
    },
    async uploadBlog() {
      this.post("blog");
    },
  },
};
</script>

<style scoped>
button {
  @apply mt-4;
}

input {
  width: 100%;
}

.cardContainer {
  margin: 24px auto 0 auto;
  width: 800px;
}
</style>
